import { useState } from 'react';
import { HOT_KEYWORDS } from '@/pages/home/data';

export default function Hero() {
  const [kw, setKw] = useState('');

  return (
    <section id="top" className="relative flex min-h-[88vh] w-full items-center overflow-hidden">
      {/* full-bleed backdrop */}
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20moody%20empty%20livestream%20broadcast%20studio%20at%20night%20with%20a%20single%20glowing%20ring%20light%20and%20phone%20silhouette%2C%20deep%20crimson%20and%20black%20palette%2C%20film%20grain%2C%20cinematic%20editorial%20gossip%20news%20backdrop%2C%20high%20contrast%2C%20abstract%20and%20artistic%2C%20clean%20composition&width=1600&height=1000&seq=hero-td-main&orientation=landscape"
        alt="抖阴黑料主播塌房事件首屏主视觉"
        title="抖阴黑料 · 主播塌房事件"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-black/20" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-16 pt-32 md:px-6">
        <div className="w-full max-w-3xl">
          {/* eyebrow */}
          <div className="flex items-center gap-3 text-white/90">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary-400" />
            </span>
            <span className="text-xs font-semibold tracking-[0.28em]">BREAKING · 塌房速报已更新</span>
            <span className="hidden text-xs text-white/50 sm:inline">第 2026-0909 期</span>
          </div>

          {/* headline */}
          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-white md:text-6xl">
            主播塌房名单曝光
            <br />
            <span className="text-primary-300">黑料合集</span> 持续打包
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-white/80 md:text-lg">
            从翻车现场到黑历史深扒，网红主播名单一一对应。这里只做一件事：
            <span className="text-white">把被删掉的、吵不清的，摊开给你看。</span>
          </p>

          {/* search */}
          <div className="mt-8 flex max-w-xl flex-col gap-3 sm:flex-row sm:items-center">
            <div className="flex flex-1 items-center gap-2 rounded-md bg-white/95 px-4 py-1.5 ring-1 ring-white/40">
              <i className="ri-search-line text-lg text-foreground-500" />
              <input
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="搜你想吃的瓜：主播名 / 塌房事件 / 关键词"
                className="h-10 w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
              />
            </div>
            <a
              href="#hot"
              className="inline-flex h-[52px] items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:h-auto sm:py-0"
            >
              开搜吃瓜
            </a>
          </div>

          {/* hot chips */}
          <div className="mt-6 flex max-w-3xl flex-wrap items-center gap-2">
            <span className="mr-1 text-xs text-white/55 whitespace-nowrap">今日热门 ·</span>
            {HOT_KEYWORDS.map((h) => (
              <a
                key={h}
                href="#hot"
                className="whitespace-nowrap rounded-full border border-white/20 bg-white/5 px-3 py-1.5 text-xs text-white/85 backdrop-blur transition-colors hover:border-primary-400 hover:bg-primary-500/20 hover:text-white"
              >
                {h}
              </a>
            ))}
          </div>
        </div>

        {/* bottom stat strip */}
        <div className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-px overflow-hidden rounded-xl border border-white/15 bg-white/15 backdrop-blur sm:grid-cols-4">
          {[
            { n: '1,284', t: '黑料条目持续更新' },
            { n: '62', t: '主播名单在线对应' },
            { n: '9', t: '塌房事件实锤归档' },
            { n: '3.2亿', t: '吃瓜热度累计' },
          ].map((s) => (
            <div key={s.t} className="bg-background-950/40 px-5 py-4">
              <div className="font-heading text-xl font-black text-accent-300 md:text-2xl">{s.n}</div>
              <div className="mt-1 text-xs text-white/65">{s.t}</div>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#hot"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-white/70 transition-colors hover:text-white"
      >
        <i className="ri-arrow-down-line text-xl" />
      </a>
    </section>
  );
}